import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

interface WrapperProps {
  error: number;
}

export const Wrapper = styled(Box)<WrapperProps>(({ error }) => ({
  position: 'relative',
  padding: '0 15px 0 15px',
  border: `1px solid ${error ? '#F44336' : 'rgba(221, 221, 234, 1)'}`,
  borderRadius: '6px',
}));

export const ChipsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '15px 2px 20px 0',
  height: '218px',
  boxSizing: 'border-box',
  overflowX: 'hidden',
  overflowY: 'auto',
}));

export const CalculatorMenu = styled(Box)(() => ({
  position: 'absolute',
  left: '50%',
  bottom: '-17px',
  transform: 'translate(-50%, 0)',
  display: 'flex',
  gap: '10px',
  padding: '4px 9px',
  borderRadius: '6px',
  zIndex: 1,
  background: 'white',
  border: '1px solid rgba(221, 221, 234, 1)',

  '.MuiIconButton-root': {
    borderRadius: '6px',
    padding: '0',

    '&:hover': {
      background: 'rgba(201, 255, 235, 1)',
    },

    '&:active': {
      background: 'rgba(30, 237, 159, 1)',
    },
  },
}));

export const Loader = styled(CircularProgress)(() => ({
  margin: 'auto',
}));

export const ButtonContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  marginTop: 'auto',

  '.MuiButtonBase-root': {
    padding: '6px 9.5px 7px',
    marginRight: '5px',
    minWidth: 'fit-content',
  },

  '.MuiTypography-root': {
    fontSize: '16px',
    lineHeight: '20.8px',
    color: 'rgba(159, 159, 159, 1)',
  },

  svg: {
    marginTop: '3px',
    width: '18px',
    height: '18px',
    color: 'rgba(159, 159, 159, 1)',
  },
}));
